<div *ngIf="isLoaded">
    <div class="row">
        <div class="col-md-6 col-12 mb-4">
            <a routerLink="../../../top-management/editare-tm/{{postData.id}}" class="btn text-white green-bg">Editeaza
                Postare</a>
        </div>
    </div>

    <div class="card card-custom gutter-b">
        <div class="card-header">
            <div class="card-title">
                <h3 class="card-label">Nume Postare: {{postData.title}}</h3>
            </div>
            <div class="card-title">
                <h3 class="card-label">Status: {{postData.status | enumTransform}}</h3>
            </div>
        </div>

        <div class="card-body">
            <div class="row mb-10">
                <div class="col-md-6 col-12">
                    <span class="font-weight-bold">Data Postare:</span> {{postData.date}}
                </div>
                <div class="col-md-6 col-12">
                    <span class="font-weight-bold">Categorii: </span>
                    <div *ngFor="let category of postData.categories" class="d-inline-block items-enum">{{category}}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-12">
                    <ul class="list-unstyled" *ngFor="let file of postData.files">
                        <li><span class="font-weight-bold mr-2">Nume Fisier:</span>{{file.name}}</li>
                        <li><a href="{{file.link}}" class="font-weight-bold" target="_blank">Link</a></li>
                        <hr>
                    </ul>
                </div>
                <div class="col-md-6 col-12">
                    <span class="font-weight-bold" *ngIf="postData.description">Descriere:</span> {{postData.description}}
                </div>
            </div>
            <div class="row justify-content-flex-end">
                <div class="col-12">
                    <div class="d-flex justify-content-end">
                        <div class="form-group" *ngIf="!checkIfUserConsent">
                            <input type="checkbox" class="form-check-input" name="userConsent" id="userConsent"
                                   [(ngModel)]="consentResponse" (change)="userGiveConsent()">
                            <label for="userConsent" class="font-weight-bold">Am luat la cunostinta</label>
                        </div>

                        <div class="form-group" *ngIf="checkIfUserConsent">
                            <span class="green-color font-weight-bold">Ai luat la cunostinta!</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
